"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.partnerBannerErrorLens = exports.evergreenPromotionErrorLens = exports.activePromotionErrorLens = exports.currentPromotionErrorLens = exports.partnerBannerLoadingLens = exports.evergreenPromotionLoadingLens = exports.activePromotionLoadingLens = exports.currentPromotionLoadingLens = exports.partnerBannerValueLens = exports.evergreenPromotionValueLens = exports.activePromotionValueLens = exports.currentPromotionValueLens = void 0;
const lenses_1 = require("@atomic-object/lenses");
const monet_1 = require("monet");
const select_1 = require("../redux/select");
const select_2 = require("./select");
const valueLens = (value) => (param) => ({
    ...param,
    error: (0, monet_1.None)(),
    value: value
});
const loadingLens = (loading) => (param) => ({
    ...param,
    loading: loading
});
const errorLens = (error) => (param) => ({
    ...param,
    error: error
});
exports.currentPromotionValueLens = lenses_1.Lens.of({
    get: (state) => (0, select_1.selectParsedCurrentPromotion)(state),
    set: (state, val) => state.update('currentPromotion', valueLens(val))
});
/**
 * @deprecated This function will not be used once we no longer request both endpoints from the
 * frontend on a page load.
 */
exports.activePromotionValueLens = lenses_1.Lens.of({
    get: (state) => (0, select_1.selectParsedActivePromotion)(state),
    set: (state, val) => state.update('activePromotion', valueLens(val))
});
/**
 * @deprecated This function will not be used once we no longer request both endpoints from the
 * frontend on a page load.
 */
exports.evergreenPromotionValueLens = lenses_1.Lens.of({
    get: (state) => (0, select_2.selectEvergreenPromo)(state),
    set: (state, val) => state.update('evergreenPromotion', valueLens(val))
});
exports.partnerBannerValueLens = lenses_1.Lens.of({
    // TODO: replace state.get() w/ selector?
    get: (state) => state.get('partnerBanner').value,
    set: (state, val) => state.update('partnerBanner', valueLens(val))
});
exports.currentPromotionLoadingLens = lenses_1.Lens.of({
    get: (state) => state.get('currentPromotion').loading,
    set: (state, val) => state.update('currentPromotion', loadingLens(val))
});
exports.activePromotionLoadingLens = lenses_1.Lens.of({
    get: (state) => state.get('activePromotion').loading,
    set: (state, val) => state.update('activePromotion', loadingLens(val))
});
/**
 * @deprecated This function will not be used once we no longer request both endpoints from the
 * frontend on a page load.
 */
exports.evergreenPromotionLoadingLens = lenses_1.Lens.of({
    get: (state) => state.get('evergreenPromotion').loading,
    set: (state, val) => state.update('evergreenPromotion', loadingLens(val))
});
exports.partnerBannerLoadingLens = lenses_1.Lens.of({
    get: (state) => state.get('partnerBanner').loading,
    set: (state, val) => state.update('partnerBanner', loadingLens(val))
});
exports.currentPromotionErrorLens = lenses_1.Lens.of({
    get: (state) => state.get('currentPromotion').error,
    set: (state, val) => state.update('currentPromotion', errorLens(val))
});
exports.activePromotionErrorLens = lenses_1.Lens.of({
    get: (state) => state.get('activePromotion').error,
    set: (state, val) => state.update('activePromotion', errorLens(val))
});
/**
 * @deprecated This function will not be used once we no longer request both endpoints from the
 * frontend on a page load.
 */
exports.evergreenPromotionErrorLens = lenses_1.Lens.of({
    get: (state) => state.get('evergreenPromotion').error,
    set: (state, val) => state.update('evergreenPromotion', errorLens(val))
});
exports.partnerBannerErrorLens = lenses_1.Lens.of({
    get: (state) => state.get('partnerBanner').error,
    set: (state, val) => state.update('partnerBanner', errorLens(val))
});
//# sourceMappingURL=lenses.js.map